import styles from './inicio.module.scss';
import logoCircle from '../img/balvanera-logo-circle.svg';
import Layout from '../components/layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import Section1 from '../components/section-slider';
import Section2 from '../components/section2';
import Section3 from '../components/section3';
import Section4 from '../components/section4';
import React from 'react';
export default () => (
  <div className={styles.testclass}>
    <Layout>
      <div id="inicio" className="">
        <Section1 />
      </div>
      <div className="position-relative">
        <div className={styles.imgLogo + ' position-absolute'}>
          <img src={logoCircle} className="img-fluid lazyload" alt="Logo" />
        </div>
        <Section2 />
      </div>
      <div className="">
        <Section3 />
      </div>
      <div>
        <Section4 />
      </div>
    </Layout>
  </div>
);
